var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Browse-Cloud") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Browse-Cloud",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Download",
    transform: "translate(10.000000, 11.000000) scale(1, -1) translate(-10.000000, -11.000000) translate(2.000000, 1.000000)",
    fill: "#B7844D"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "6.99558814 0 6.99558814 12.4718602 3.43894658 9.28651281 2 10.5851544 8.00013575 16 14 10.5851544 12.5613249 9.28651281 9.0318333 12.4718602 9.0318333 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "0 20 16 20 16 18 0 18"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.c3b1044164d6da2406100f48a2d29c60.svg";
export { ForwardRef as ReactComponent };